export default __webpack_public_path__ + "static/media/walkthrough-1.38c19874.png";